import { useDeepCompareMemo } from '@src/hooks';

/**
 * Stabilizes data using deep comparison to prevent unnecessary re-renders
 * when the data array reference changes but the actual data is the same
 */
export const useStableData = <T>(data: T[] = []): T[] => {
  return useDeepCompareMemo(() => data, [data]);
};
